export const RADAR_PROFILE_AXES = [
  {
    id: "fab",
    label: "FAB",
    aliases: ["fab"],
  },
  {
    id: "hinting",
    label: "Hinting",
    aliases: ["hinting_test", "hinting"],
  },
  {
    id: "eyes",
    label: "Eyes",
    aliases: ["reading_the_mind_in_the_eyes", "reading_the_mind_in_the_eyes_test"],
  },
  {
    id: "empathy",
    label: "Empathy",
    aliases: ["empathy_test", "empathy"],
  },
  {
    id: "beck_dep",
    label: "Beck Depresión",
    aliases: ["depression_beck_test", "beck_depression"],
  },
  {
    id: "beck_anx",
    label: "Beck Ansiedad",
    aliases: ["anxiety_beck_test", "beck_anxiety"],
  },
  {
    id: "yesavage",
    label: "Yesavage",
    aliases: ["depression_yesavage_test", "yesavage"],
  },
  {
    id: "barthel",
    label: "Barthel",
    aliases: ["barthel_test", "barthel", "indice_de_barthel"],
  },
];

export const normalizeTestName = (name) =>
  String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, "_");

const matchesRadarTest = (testName, aliases) => {
  const normalized = normalizeTestName(testName);
  return aliases.some(
    (alias) => normalized === alias || normalized.includes(alias)
  );
};

const pickLatestTest = (tests) => {
  if (!tests.length) return null;

  return tests.reduce((latest, test) => {
    if (!latest) return test;

    const testDate = new Date(test.testDay).getTime();
    const latestDate = new Date(latest.testDay).getTime();

    if (testDate !== latestDate) {
      return testDate > latestDate ? test : latest;
    }

    return test;
  }, null);
};

export const buildCognitiveRadarProfile = (tests = []) => {
  return RADAR_PROFILE_AXES.map((axis) => {
    const matchingTests = tests.filter((test) =>
      matchesRadarTest(test.testName, axis.aliases)
    );
    const latestTest = pickLatestTest(matchingTests);
    const rawPercentage = latestTest?.percentage;

    let percentage = null;
    if (rawPercentage != null && !Number.isNaN(Number(rawPercentage))) {
      percentage = Math.min(100, Math.max(0, Number(rawPercentage)));
    }

    return {
      ...axis,
      percentage,
      hasData: percentage != null,
      testDay: latestTest?.testDay ?? null,
    };
  });
};

export const countRadarDataPoints = (profile) =>
  profile.filter((axis) => axis.hasData).length;
